import api from '../api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Designer Design Case API functions
export const designerDesignCaseApi = {
  // Lấy tất cả available cases (chưa được assign)
  getAvailableCases: async (token) => {
    try {
      const response = await api.get('/design-cases/available', {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getSellerCases: async (token, params = {}) => {
    
  },

 
  getMyCases: async (token, params = {}) => {
    try {
      const response = await api.get('/design-cases/assigned', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy chi tiết design case
  getDesignCaseById: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case by ID:', error);
      throw error;
    }
  },

  // Assign case cho designer
  assignCase: async (token, caseId) => {
    try {
      const response = await api.put(`design-cases/${caseId}/assign`,{}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error assigning case:', error);
      throw error;
    }
  },

  // Unassign case (trả lại case)
  unassignCase: async (token, caseId) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}/unassign`, {}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error unassigning case:', error);
      throw error;
    }
  },

  // Cập nhật design case
  updateDesignCase: async (token, caseId, caseData) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}`, caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating design case:', error);
      throw error;
    }
  },

  // Upload design file
  uploadDesignFile: async (token, caseId, fileData) => {
    try {
      const formData = new FormData();
      formData.append('file', fileData);
      
      const response = await api.post(`/designer/cases/${caseId}/upload`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading design file:', error);
      throw error;
    }
  },

  // Upload multiple design files
  uploadMultipleDesignFiles: async (token, caseId, files) => {
    try {
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append('files', file);
      });
      
      const response = await api.post(`/designer/cases/${caseId}/upload-multiple`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading multiple design files:', error);
      throw error;
    }
  },

  // Delete design file
  deleteDesignFile: async (token, caseId, fileId) => {
    try {
      const response = await api.delete(`/designer/cases/${caseId}/files/${fileId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting design file:', error);
      throw error;
    }
  },

  // Mark case as completed
  completeCase: async (token, caseId, completionData = {}) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}/complete`, completionData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error completing case:', error);
      throw error;
    }
  },

  // Get design case timeline
  getDesignCaseTimeline: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}/timeline`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case timeline:', error);
      throw error;
    }
  },

  // Get design case comments
  getDesignCaseComments: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}/comments`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case comments:', error);
      throw error;
    }
  },

  // Add comment to design case
  addDesignCaseComment: async (token, caseId, commentData) => {
    try {
      const response = await api.post(`/designer/cases/${caseId}/comments`, commentData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error adding design case comment:', error);
      throw error;
    }
  },

  // Update comment
  updateDesignCaseComment: async (token, caseId, commentId, commentData) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}/comments/${commentId}`, commentData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating design case comment:', error);
      throw error;
    }
  },

  // Delete comment
  deleteDesignCaseComment: async (token, caseId, commentId) => {
    try {
      const response = await api.delete(`/designer/cases/${caseId}/comments/${commentId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting design case comment:', error);
      throw error;
    }
  },

  // Get design case attachments
  getDesignCaseAttachments: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}/attachments`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case attachments:', error);
      throw error;
    }
  },

  // Upload attachment to design case
  uploadDesignCaseAttachment: async (token, caseId, file, description = '') => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('description', description);

      const response = await api.post(`/designer/cases/${caseId}/attachments`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading design case attachment:', error);
      throw error;
    }
  },

  // Delete attachment
  deleteDesignCaseAttachment: async (token, caseId, attachmentId) => {
    try {
      const response = await api.delete(`/designer/cases/${caseId}/attachments/${attachmentId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting design case attachment:', error);
      throw error;
    }
  },

  // Get design case history
  getDesignCaseHistory: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}/history`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case history:', error);
      throw error;
    }
  },

  // Request deadline extension
  requestDeadlineExtension: async (token, caseId, extensionData) => {
    try {
      const response = await api.post(`/designer/cases/${caseId}/request-extension`, extensionData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error requesting deadline extension:', error);
      throw error;
    }
  },

  // Get design case analytics
  getDesignCaseAnalytics: async (token, caseId) => {
    try {
      const response = await api.get(`/designer/cases/${caseId}/analytics`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case analytics:', error);
      throw error;
    }
  },

  // Search design cases
  searchDesignCases: async (token, searchParams) => {
    try {
      const response = await api.get('/designer/cases/search', {
        headers: getAuthHeaders(token),
        params: searchParams
      });
      return response;
    } catch (error) {
      console.error('Error searching design cases:', error);
      throw error;
    }
  },

  // Filter design cases
  filterDesignCases: async (token, filters) => {
    try {
      const response = await api.get('/designer/cases/filter', {
        headers: getAuthHeaders(token),
        params: filters
      });
      return response;
    } catch (error) {
      console.error('Error filtering design cases:', error);
      throw error;
    }
  },

  // Get design case templates
  getDesignCaseTemplates: async (token) => {
    try {
      const response = await api.get('/designer/cases/templates', {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case templates:', error);
      throw error;
    }
  },

  // Create design case from template
  createDesignCaseFromTemplate: async (token, templateId, caseData) => {
    try {
      const response = await api.post(`/designer/cases/templates/${templateId}/create`, caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error creating design case from template:', error);
      throw error;
    }
  },

  // Get design case notifications
  getDesignCaseNotifications: async (token) => {
    try {
      const response = await api.get('/designer/cases/notifications', {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting design case notifications:', error);
      throw error;
    }
  },

  // Mark notification as read
  markNotificationAsRead: async (token, notificationId) => {
    try {
      const response = await api.put(`/designer/notifications/${notificationId}/read`, {}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  // Mark all notifications as read
  markAllNotificationsAsRead: async (token) => {
    try {
      const response = await api.put('/designer/notifications/read-all', {}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }
};

export default designerDesignCaseApi; 